// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qki4","content":"styles_content__2avvR","row":"styles_row__3KioU","footer":"styles_footer__2sQcH","phraseLength":"styles_phraseLength___cef5"};